import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import Dest from '../Specifiche/Dest/Dest';
import Faq from '../Specifiche/Faq/Faq';

import { Panel } from 'primereact/panel';
import { flushCache } from '../../api/ChatbotApi';
import './CatalogoOggetti.css';


function CatalogoOggetti(props) {

  const { storage } = usePJStore((state) => state.storage)


  const getText = usePJStore((state) => state.i18n_getText)
  const [expandedRows, setExpandedRows] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [modifiedItems, setModifiedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const [operation, setOperation] = useState("list");
  const [unusedFlag, setUnusedFlag] = useState(false);

  const [editDialog, setEditDialog] = useState(false);
  const [editData, setEditData] = useState({});

  const [myFaqs, setMyFaqs] = useState(props.myFaqs);

  const [myDests, setMyDests] = useState(props.myDests);

  const [gruppo, setGruppo] = useState(null);
  const [gruppi, setGruppi] = useState(null);

  const dbTest = usePJStore((state) => state.appInfo_dbTest);

  useEffect(() => {
    getGroups();
  }, []);


  useEffect(() => {
    setMyFaqs(props.myFaqs)
    setLoading(false)
  }, [props.myFaqs]);

  useEffect(() => {
    setMyDests(props.myDests)
    setLoading(false)
  }, [props.myDests]);


  const getGroups = () => {
    PJAxios().post('/gestioneConfigurazioni/getGroups', { type: "Q" }).then((res) => {

      let items = res.data;
      items.unshift({ tag: getText("ALL"), conteggio: 0, filter: false })

      setGruppi(items);
      setGruppo({ tag: getText("ALL"), conteggio: 0, filter: false });
    });
  }

  useEffect(() => {
    filterItems(myFaqs, props.myFaqs, "FAQ");
    filterItems(myDests, props.myDests, "DESTS");
  }, [gruppo, unusedFlag]);

  function filterItems(list, completeList, itemType) {

    let items = [];

    if (gruppo === null || (gruppo != null && gruppo.filter != null && !gruppo.filter)) {
      completeList.forEach((element) => {

        var usi = 0;
        try {
          usi = element.numeroUsi;
        } catch (e) {
           //console.log("numero_istanze error")
        }

        var test = (unusedFlag && usi === 0) || (!unusedFlag);
        if (test) {
          items.push(element);
        }

      })
      if (itemType === 'FAQ') {
        setMyFaqs(items);
      } else if (itemType === 'DESTS') {
        setMyDests(items)
      }
    } else if (gruppo != null) {


      completeList.forEach((element) => {

        var sameGroup = element.gruppo === gruppo.tag;

        var usi = 0;

        try {
          usi = element.numeroUsi;
        } catch (e) {
           //console.log("numero_istanze error")
        }


        var unusedFlagtest = unusedFlag ? (usi === 0) : true;
        if (sameGroup && unusedFlagtest) {
          items.push(element);
        }
      })
      if (itemType === 'FAQ') {
        setMyFaqs(items);
      } else if (itemType === 'DESTS') {
        setMyDests(items)
      }
    }
  }

  useEffect(() => {
    if (modifiedItems.length > 0) {
      salvaTutto(true);
    }
  }, [modifiedItems]);

  useEffect(() => {

    if (detail != null) {
      confirmPopup({
        target: document.getElementById(selectedNode.idItem),
        message: getMessage,
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        accept: eliminaItem,
        reject: reject
      });
    }

  }, [selectedNode]);

  useEffect(() => {

  }, [editData]);


  const modificaFaq = (rowdata) => {

    let item = {
      elemento: rowdata
    }

    setEditData(item);
    setEditDialog(true);

  }

  const eliminaItem = () => {
    let items = [];
    items.push({ is_new: false, id_tree: "jstree_faq", id_item: selectedNode.idItem, op_type: "del_all" });
    setModifiedItems(items);
  }

  const salvaTutto = (catalogo) => {
    setLoading(true);
    PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedItems, idConfig: props.idConfig }).then((res) => {

      if (res.data.error.exceptional_element.length > 0) {
        props.onError(res.data.error.exceptional_element);
      } else {
        //console.log("catalogoOggetti salva tutto - bundle refresh")
        if (catalogo) {
          props.onCatalogoSave();
        } else {
          props.onSave();
        }
        flushCache(dbTest);
      }
      setModifiedItems([]);

    }).finally(() => {
      setLoading(false)
    })

  }

  const reject = () => {

  };


  const rowExpansionTemplate = (data) => {
    return (
      <div className="formgroup-inline col-12 md:col-12">
        <div className="col-6 md:col-6">

          <div className="col-12 md:col-12" dangerouslySetInnerHTML={{ __html: data.risposta_it }}>
          </div>
        </div>
        <div className="col-6 md:col-6">
          <div className="col-12 md:col-12" dangerouslySetInnerHTML={{ __html: data.risposta_en }}>
          </div>
        </div>
      </div>
    );
  }

  const getMessage = () => {
    var message = "";
    let count = 0;
    try {
      count = selectedNode.numeroUsi;
    } catch (e) {
       //console.log("numero_istanze error")
    }
    if (count > 0) {
      message = getText("TEMATICHE_PRESENZA_ITEM") + ": ";
      detail.tematiche.forEach((tematica, index) => {
        message = message + '"' + tematica.name + '",\n';
      })
    }

    message = message + getText("CONFERMA_OPERAZIONE");
    return (<p>{message}</p>);
  }


  const confirmOperation = (rowData, message) => {
    var url = '/gestioneConfigurazioni/getItemDetail/' + rowData.idItem;
    PJAxios().get(url).then((res) => {
      setDetail(res.data);
      setSelectedNode(rowData);
    });

  };

  const actionBodyTemplate = (rowData) => {
    try {
      const d = (rowData.numeroUsi === 0);
      const d2 = (rowData.numeroUsi > 0);
       //console.log("rowactionBodyTemplatedata", rowData)

      return (
        <table>
          <tr>
            <td><Button label={getText("MODIFICA")} className='p-button-secondary' icon="pi pi-pencil" onClick={() => { modificaFaq(rowData) }} /></td>

            <td>
              {d &&
                <Button id={rowData.idItem} label={getText("CANCELLA")} className='p-button-danger' icon="pi pi-trash" onClick={() => { confirmOperation(rowData, getText("CONFERMA_OPERAZIONE")) }} />
              }
              {d2 &&
                <Button id={rowData.idItem} label={getText("CANCELLA")} className='p-button-warning' icon="pi pi-exclamation-circle" onClick={() => { confirmOperation(rowData, getText("CONFERMA_OPERAZIONE")) }} />
              }
            </td>
          </tr>
        </table>

      );
    } catch (e) {
       //console.log("actionBodyTemplate error", e)
      return ""
    }

  }

  const usiBodyTemplate = (rowData) => {
     //console.log("usiBodyTemplate", rowData)
    try {
      const d = rowData.numeroUsi
      return (
        <>
          {d}
        </>
      );
    } catch (e) {
       //console.log("usiBodyTemplate error")
      return ""
    }

  }

  const onCatalogoSave = (tematica, ret, chiudi) => {
    props.onCatalogoSave(tematica, true)
    //console.log("catalogoOggetti onCatalogoSave - bundle refresh")

    /*setOfflineBundles({it: {
    
        },en:{
            
        }
    })*/

    setOperation("list");
    if (chiudi) {
      setEditDialog(false)
    }
  }


  const onSave = (tematica, ret) => {
    props.onSave(tematica, true)
    setOperation("list");
  }

  const onNodeLoaded = () => {

  }

  const onModificationReceived = () => {

  }

  const showElencoFaq = () => {
    setOperation("list");
  }

  const showCreaFaq = () => {
    setOperation("create");
  }

  const hideDialog = () => {
    setEditData(null);
    setEditDialog(false);
  }


  return (
    <>
      {loading &&
        <ProgressSpinner />
      }

      {!loading &&
        <div>

          <ConfirmPopup />
          <Panel header={getText("CATALOGO_OGGETTI")} className='surface-card' >

            <div>&nbsp;</div>
            <TabView className="treebox" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
              <TabPanel header={getText("FAQ")} >

                <div className="formgroup-inline col-12 md:col-12">
                  <div className="col-2 md:col-2">
                    <div className="p-fluid grid formgrid col-12">
                      <div className="field col-12 md:col-12">
                        <Button label={getText("ELENCO_FAQ")} className='p-button-primary' icon="pi pi-list" onClick={showElencoFaq} />
                      </div>
                      <div className="field col-12 md:col-12">
                        <Button label={getText("CREA_FAQ")} className='p-button-primary' icon="pi pi-plus" onClick={showCreaFaq} />
                      </div>
                    </div>
                  </div>
                  <div className="col-10 md:col-10">
                    {operation === 'create' &&
                      <Panel className='surface-card' header={getText("CREA_FAQ")} >
                        <Faq onFaqCreated={onCatalogoSave} gruppi={gruppi} isNew={true} onSave={onCatalogoSave} idConfig={props.idConfig} selectedNode={props.selectedNode} onNodeLoaded={onNodeLoaded} onModificationReceived={onModificationReceived} />
                      </Panel>
                    }

                    {operation === 'list' &&
                      <Panel className='surface-card' header={getText("ELENCO_FAQ")} >
                        <div className="formgroup-inline col-12 md:col-12">
                          <div className="col-4 md:col-4">
                            {getText("SELEZIONA_GRUPPO")}
                            <Dropdown value={gruppo} options={gruppi} onChange={(e) => setGruppo(e.value)} optionLabel="tag" filter filterBy="tag" placeholder={getText("SELEZIONA_GRUPPO_PLACEHOLDER")}
                            />
                          </div>
                          <div className="col-4 md:col-4">
                            {getText("MOSTRA_SOLO_INUTILIZZATI")}
                            <Checkbox onChange={e => setUnusedFlag(e.checked)} checked={unusedFlag}></Checkbox>

                          </div>
                        </div>




                        <DataTable title={getText("ELENCO_FAQ")} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                          rowExpansionTemplate={rowExpansionTemplate} dataKey="idItem"
                          scrollable scrollHeight="400px" virtualScrollerOptions={{ itemSize: 46 }}
                          size="small" stripedRows rows={100} value={myFaqs} >
                          <Column expander style={{ maxWidth: '3em' }} />
                          <Column className="centeredColumn" field="domanda_it" tooltip="risposta_it" header={getText("DOMANDA_IT")}></Column>
                          <Column className="centeredColumn" field="domanda_en" header={getText("DOMANDA_EN")}></Column>
                          <Column className="centeredColumn" field="gruppo" header={getText("GRUPPO")}></Column>
                          <Column className="centeredColumn" field="proprietario" header={getText("OWNER")}></Column>
                          <Column style={{ maxWidth: '3em' }} body={usiBodyTemplate} header={getText("USI")} exportable={false}></Column>
                          <Column body={actionBodyTemplate} header={getText("AZIONI")} exportable={false}></Column>
                        </DataTable>
                      </Panel>
                    }

                  </div>
                </div>

              </TabPanel>
              <TabPanel header={getText("DESTS")} >
                <div className="formgroup-inline col-12 md:col-12">
                  <div className="col-2 md:col-2">
                    <div className="p-fluid grid formgrid col-12">
                      <div className="field col-12 md:col-12">
                        <Button label={getText("ELENCO_DESTS")} className='p-button-primary' icon="pi pi-list" onClick={showElencoFaq} />
                      </div>
                      <div className="field col-12 md:col-12">
                        <Button label={getText("CREA_DESTS")} className='p-button-primary' icon="pi pi-plus" onClick={showCreaFaq} />
                      </div>
                    </div>
                  </div>
                  <div className="col-10 md:col-10">
                    {operation === 'create' &&
                      <Panel className='surface-card' header={getText("CREA_DESTS")} >
                        <Dest gruppi={gruppi} isNew={true} onSave={onCatalogoSave} idConfig={props.idConfig} selectedNode={props.selectedNode} onNodeLoaded={onNodeLoaded} onModificationReceived={onModificationReceived} />
                      </Panel>
                    }

                    {operation === 'list' &&
                      <Panel className='surface-card' header={getText("ELENCO_DESTS")} >
                        <div className="formgroup-inline col-12 md:col-12">
                          <div className="col-4 md:col-4">
                            {getText("SELEZIONA_GRUPPO")}
                            <Dropdown value={gruppo} options={gruppi} onChange={(e) => setGruppo(e.value)} optionLabel="tag" filter filterBy="tag" placeholder={getText("SELEZIONA_GRUPPO_PLACEHOLDER")}
                            />
                          </div>
                          <div className="col-4 md:col-4">
                            {getText("MOSTRA_SOLO_INUTILIZZATI")}
                            <Checkbox onChange={e => setUnusedFlag(e.checked)} checked={unusedFlag}></Checkbox>

                          </div>
                        </div>


                        <DataTable scrollable scrollHeight="700px" showGridlines size="small" stripedRows rows={100} value={myDests} responsiveLayout="scroll">
                          <Column className="centeredColumn" field="label_it" tooltip="extra_fields.risposta_it" header={getText("DOMANDA_IT")}></Column>
                          <Column className="centeredColumn" field="label_en" header={getText("DOMANDA_EN")}></Column>
                          <Column className="centeredColumn" field="email" header={getText("EMAIL")}></Column>
                          <Column className="centeredColumn" field="gruppo" header={getText("GRUPPO")}></Column>
                          <Column style={{ width: '3em' }} body={usiBodyTemplate} header={getText("USI")} exportable={false}></Column>
                          <Column body={actionBodyTemplate} header={getText("AZIONI")} exportable={false}></Column>
                        </DataTable>
                      </Panel>
                    }

                  </div>
                </div>
              </TabPanel>
            </TabView>
          </Panel>

          <Dialog visible={editDialog} style={{ width: '80%' }} header={getText("MODIFICA_FAQ")} modal className="p-fluid" onHide={hideDialog}>
            <Faq dialog={true} gruppi={gruppi} isNew={false} onSave={onCatalogoSave} onFaqCreated={onCatalogoSave} idConfig={props.idConfig} selectedNode={editData} onNodeLoaded={onNodeLoaded} onModificationReceived={onModificationReceived} />

          </Dialog>
        </div>

      }
    </>
  )
}

export default CatalogoOggetti
